export const qleList = [
  { label: 'Death in family', value: 'death_in_family' },
  { label: 'New Birth', value: 'new_birth' },
  { label: 'Marriage/Divorce', value: 'marriage_divorce' },
  { label: 'Loss of coverage', value: 'loss_of_coverage' },
  { label: 'Reduction in income/hours', value: 'reduction_in_income' },
  { label: 'Change in residence', value: 'change_in_residence' },
  { label: 'Change to full time', value: 'change_to_full_time' }
]
